import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { DocumentoPreEditadoService } from '../../_services/DocumentoPreEditado.service';
import { DocumentoPreEditado } from '../../_models/DocumentoPreEditado';
import { Message, User, Filtro, AprovadorSLD,Fornecedor, Responsavel, StatusProtocolo, TipoDocumento, PesquisaProtocolos } from '../../_models';
import { MaskService } from 'src/app/_services/mask.service';
import { UsuariosResponsaveisService, StatusProtocoloService, AprovadorSLDService } from '../../_services';
import { TipoService } from 'src/app/_services/tipo.service';
import { AppComponent } from '../../app.component';
import { PopupFiltroPesquisaComponent } from '../popup-filtro-pesquisa/popup-filtro-pesquisa.component';
import { FiltroPesquisaService } from '../../_services/filtroPesquisa.service';
import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';
import moment from 'moment';
import { PopupMessagesNewStyleTestComponent } from '../popup-messages-new-style-test/popup-messages-new-style-test.component';
import { CNPJAlfa } from 'src/app/_helpers/cnpj-alfa.util';

@Component({
  selector: 'app-acompanhamento',
  templateUrl: './acompanhamento.component.html',
  styleUrls: ['./acompanhamento.component.css']
})

export class AcompanhamentoComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('inputDataCriacaoInicio', { read: ViewContainerRef, static: true }) public inputDataCriacaoInicio;
  @ViewChild('inputDataCriacaoFim', { read: ViewContainerRef, static: true }) public inputDataCriacaoFim;
  @ViewChild('inputDataEmissaoInicio', { read: ViewContainerRef, static: true }) public inputDataEmissaoInicio;
  @ViewChild('inputDataEmissaoFim', { read: ViewContainerRef, static: true }) public inputDataEmissaoFim;
  @ViewChild('inputDataVencimentoInicio', { read: ViewContainerRef, static: true }) public inputDataVencimentoInicio;
  @ViewChild('inputDataVencimentoFim', { read: ViewContainerRef, static: true }) public inputDataVencimentoFim;
  @ViewChild('inputDataConclusaoInicio', { read: ViewContainerRef, static: true }) public inputDataConclusaoInicio;
  @ViewChild('inputDataConclusaoFim', { read: ViewContainerRef, static: true }) public inputDataConclusaoFim;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  currentUser: User;
  messageModel: Message;
  lstProtocolos = new Array<DocumentoPreEditado>();
  placeholderTipoDocumento: string;
  lstFiltro = new Array<Filtro>();

  // Screen rules
  step = 0;
  loadAcompanhamento = false;

  // Utilities
  mask: MaskService;

  // Validators
  pesquisaForm: FormGroup;
  exibirFiltroTipoDoc = false as boolean;
  exibirFiltroTipo = false as boolean;

  displayedColumns: string[] = ['idProtocolo', 'documento', 'nomeFornecedor', 'dataEmissaoNf', 'dataVencimentoNf', 'valor', 'loginResponsavel', 'status', 'select'];
  dataSource = new MatTableDataSource<DocumentoPreEditado>(this.lstProtocolos);
  selection = new SelectionModel<DocumentoPreEditado>(true, []);
  // Criação
  maskedInputDataCriacaoInicioController;
  maskedInputDataCriacaoFimController;
  // Emissão
  maskedInputDataEmissaoInicioController;
  maskedInputDataEmissaoFimController;
  // Vencimento
  maskedInputDataVencimentoInicioController;
  maskedInputDataVencimentoFimController;
  // Conclusão
  maskedInputDataConclusaoInicioController;
  maskedInputDataConclusaoFimController;

  // Models
  public fornecedor = new Fornecedor();
  public responsavelSelected = new Responsavel();
  public statusProtocoloSelected = new StatusProtocolo();
  idTipoDocumento = {} as TipoDocumento;
  pesquisaProtocolos = new PesquisaProtocolos();

  // API's
  public responsaveis = [] as Responsavel[];
  public aprovadoresSLD = [] as AprovadorSLD[];
  public usuarios = [] as Responsavel[];
  public statusProtocolos = [] as StatusProtocolo[];
  public tipoDocs: Array<TipoDocumento>;

  constructor(
    private apiProtocolos: DocumentoPreEditadoService,
    private dateAdapter: DateAdapter<Date>,
    private formBuilder: FormBuilder,
    private apiResponsaveis: UsuariosResponsaveisService,
    private apiStatusProtocolo: StatusProtocoloService,
    private apiTipoDocService: TipoService,
    private apiFiltroPesquisa: FiltroPesquisaService,
    private loadComponent: AppComponent,
    private apiAprovadorSLDService: AprovadorSLDService,
    private dialog?: MatDialog,
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.dateAdapter.setLocale('pt-br');
    this.mask = new MaskService();
  }

  ngOnInit() {
    this.placeholderTipoDocumento = 'Tipo Documento';
    this.carregarFiltro();
    this.CarregarValidacoesTela();
    this.getResponsaveis();
    this.getStatusProtocolo();
    this.getAprovadorSLD();
    this.getUsuarios();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.maskedInputDataCriacaoInicioController = textMask.maskInput({
        inputElement: this.inputDataCriacaoInicio.element.nativeElement,
        mask: this.mask.date.mask
      });
    });

    setTimeout(() => {
      this.maskedInputDataCriacaoFimController = textMask.maskInput({
        inputElement: this.inputDataCriacaoFim.element.nativeElement,
        mask: this.mask.date.mask
      });
    });

    setTimeout(() => {
      this.maskedInputDataEmissaoInicioController = textMask.maskInput({
        inputElement: this.inputDataEmissaoInicio.element.nativeElement,
        mask: this.mask.date.mask
      });
    });

    setTimeout(() => {
      this.maskedInputDataEmissaoFimController = textMask.maskInput({
        inputElement: this.inputDataEmissaoFim.element.nativeElement,
        mask: this.mask.date.mask
      });
    });

    setTimeout(() => {
      this.maskedInputDataVencimentoInicioController = textMask.maskInput({
        inputElement: this.inputDataVencimentoInicio.element.nativeElement,
        mask: this.mask.date.mask
      });
    });

    setTimeout(() => {
      this.maskedInputDataVencimentoFimController = textMask.maskInput({
        inputElement: this.inputDataVencimentoFim.element.nativeElement,
        mask: this.mask.date.mask
      });
    });

    setTimeout(() => {
      this.maskedInputDataConclusaoInicioController = textMask.maskInput({
        inputElement: this.inputDataConclusaoInicio.element.nativeElement,
        mask: this.mask.date.mask
      });
    });

    setTimeout(() => {
      this.maskedInputDataConclusaoFimController = textMask.maskInput({
        inputElement: this.inputDataConclusaoFim.element.nativeElement,
        mask: this.mask.date.mask
      });
    });
  }

  ngOnDestroy() {
    // Criação
    this.maskedInputDataCriacaoInicioController.destroy();
    this.maskedInputDataCriacaoFimController.destroy();
    // Emissão
    this.maskedInputDataEmissaoInicioController.destroy();
    this.maskedInputDataEmissaoFimController.destroy();
    // Vencimento
    this.maskedInputDataVencimentoInicioController.destroy();
    this.maskedInputDataVencimentoFimController.destroy();
    // Conclusão
    this.maskedInputDataConclusaoInicioController.destroy();
    this.maskedInputDataConclusaoFimController.destroy();
  }

  CarregarValidacoesTela() {
    // VALIDAÇÕES FORMULÁRIO 1. TIPO DOCUMENTO
    this.pesquisaForm = this.formBuilder.group({
      frmNProtocolo: ['', Validators.nullValidator],
      frmDocumento: ['', Validators.nullValidator],
      frmCnpjFornecedor: ['', Validators.nullValidator],
      frmNomeFornecedor: ['', Validators.nullValidator],
      frmNPedido: ['', Validators.nullValidator],

      frmCriacaoInicio: [''],
      frmCriacaoFim: [''],
      frmEmissaoInicio: [''],
      frmEmissaoFim: [''],
      frmVencimentoInicio: [''],
      frmVencimentoFim: [''],
      frmConclusaoInicio: [''],
      frmConclusaoFim: [''],

      frmUsuarioCriacao: ['', Validators.nullValidator],
      frmUsuarioAprovador: ['', Validators.nullValidator],
      frmResponsavel: ['', Validators.nullValidator],
      frmMeusFiltros: ['', Validators.nullValidator],
      frmStatusProtocolo: ['', Validators.nullValidator],

      frmValor: ['', Validators.nullValidator],
      frmTipoProtocolo: ['', Validators.nullValidator],
      frmTipoDoc: ['', Validators.nullValidator],
      frmTipo: ['', Validators.nullValidator],
    });

    this.pesquisaForm.controls['frmTipo'].disable();
    this.pesquisaForm.controls['frmTipoDoc'].disable();
  }

  carregarFiltro() {
    this.apiFiltroPesquisa.ObterFiltros().subscribe(
      rtn => this.lstFiltro = rtn.data,
      err => {
        console.log(err);
        this.messageModel = new Message(
          'Filtros',
          'Erro de conexão',
          'Ocorreu um erro ao listar os filtros da base. Tente novamente.',
          'warning'
        );
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
      },
      () => {
      }
    );
  }

  getResponsaveis() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const movimentarProtocoloTerceiros = this.currentUser.movimentarProtocoloTerceiros.toString()
      .toLowerCase() === 'true';

    const visualizarProtocoloTerceiros = this.currentUser.visualizarProtocoloTerceiros.toString()
    .toLowerCase() === 'true';

    if (visualizarProtocoloTerceiros || movimentarProtocoloTerceiros) {
      this.apiResponsaveis.getResponsaveis().subscribe(data => {
        this.responsaveis = data.data;
      });

    } else if(movimentarProtocoloTerceiros){
      // Teste de Funcionários do Accenture
      const responsavel = new Responsavel();
      responsavel.montaResponsavel("agenterpa1", "agenterpa1");
      this.responsaveis.push(responsavel);
      this.pesquisaProtocolos.loginResponsavel = responsavel.login;
      this.pesquisaForm.controls['frmResponsavel'].patchValue(responsavel.login);
      this.pesquisaForm.controls['frmResponsavel'].disable();
    }else{
      const responsavel = new Responsavel();
      responsavel.montaResponsavel(this.currentUser.username, this.currentUser.login);
      this.responsaveis.push(responsavel);
      this.pesquisaProtocolos.loginResponsavel = responsavel.login;
      this.pesquisaForm.controls['frmResponsavel'].patchValue(responsavel.login);
      this.pesquisaForm.controls['frmResponsavel'].disable();
    }
  }

  getAprovadorSLD() {
    this.apiAprovadorSLDService.ObterAprovadores().subscribe(data => {
      this.aprovadoresSLD = data.data;
    });
  }

  getUsuarios() {
    this.apiResponsaveis.getUsuarioCriacao().subscribe(data => {
      this.usuarios = data.data;
    });
  }

  getStatusProtocolo() {
    this.apiStatusProtocolo.getStatusProtocolo().subscribe(data => {
      this.statusProtocolos = data.data;
    });
  }

  obterTiposDocumentoNaoFiscal() {
    this.loadAcompanhamento = true;
    this.apiTipoDocService.obterTiposDocumentoNaoFiscal().subscribe(
      data => this.tipoDocs = data.data,
      err => {
        console.error(err);
        this.messageModel = new Message(
          'Erro ao realizar integração com SAP',
          '',
          'Tente recarregar a tela novamente',
          'error'
        );
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        this.loadAcompanhamento = false;
      },
      () => {
        this.pesquisaForm.controls['frmTipoDoc'].enable();
        this.loadAcompanhamento = false;
        this.tipoDocs.sort((a, b) => a.tipoDocumento.localeCompare(b.tipoDocumento));
      }
    );
  }

  obterTiposDocumentoFiscal() {
    this.apiTipoDocService.obterTiposDocumentoFiscal().subscribe(
      data => {
        this.tipoDocs = data.data;
      },
      err => {
        console.error(err);
        this.messageModel = new Message('Erro ao realizar busca', '', 'Tente recarregar a tela novamente', 'error');
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
      },
      () => {
        this.pesquisaForm.controls['frmTipoDoc'].enable();
      }
    ).add(() => this.loadAcompanhamento = false);
  }

  carregarTipoDoc() {
    if (this.pesquisaForm.controls['frmTipoProtocolo'].value === '2') {
      this.placeholderTipoDocumento = 'Qual o tipo do Fiscal';
      this.pesquisaForm.controls['frmTipo'].enable();
      this.pesquisaForm.controls['frmTipoDoc'].setValue(null);
      this.exibirFiltroTipo = false;
      this.exibirFiltroTipoDoc = true;
      this.obterTiposDocumentoFiscal();
    } else if (this.pesquisaForm.controls['frmTipoProtocolo'].value === '1') {
      this.placeholderTipoDocumento = 'Qual o tipo do Não Fiscal';
      this.pesquisaForm.controls['frmTipo'].disable();
      this.exibirFiltroTipo = false;
      this.exibirFiltroTipoDoc = true;
      this.pesquisaForm.controls['frmTipo'].setValue(null);
      this.obterTiposDocumentoNaoFiscal();
    } else {
      this.tipoDocs = null;
      this.placeholderTipoDocumento = 'Selecione o tipo de protocolo primeiro';
      this.pesquisaForm.controls['frmTipo'].disable();
      this.pesquisaForm.controls['frmTipo'].setValue(null);
      this.pesquisaForm.controls['frmTipoDoc'].setValue(null);
      this.pesquisaForm.controls['frmTipoDoc'].disable();
      this.exibirFiltroTipoDoc = false;
      this.exibirFiltroTipo = false;
    }
  }

  sanitizarCNPJFornecedorFiltroInput(event: any) {
    // Permite apenas letras e números (sem máscara) — aceita CNPJ, CPF e código do fornecedor
    let valor = event.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    event.target.value = valor;
    this.pesquisaProtocolos.cnpjFornecedor = valor;
    this.pesquisaForm.controls['frmCnpjFornecedor'].setValue(valor, { emitEvent: false });
  }

  onCarregarLista() {
    this.loadComponent.startLoading(true);
    this.pesquisaProtocolos.idProtocolo = this.pesquisaProtocolos.idProtocolo ? parseInt(this.pesquisaProtocolos.idProtocolo.toString()) : null;
    // Remove máscara do CNPJ antes de enviar ao backend (suporta CNPJ Alfa)
    if (this.pesquisaProtocolos.cnpjFornecedor) {
      this.pesquisaProtocolos.cnpjFornecedor = CNPJAlfa.removeMascaraCNPJ(this.pesquisaProtocolos.cnpjFornecedor);
    }
    this.apiProtocolos.obterProtocolosPesquisa(this.pesquisaProtocolos).subscribe(rtn => {
      if (rtn?.data) {
        this.lstProtocolos = rtn.data;
        } else {
          this.lstProtocolos = [] as DocumentoPreEditado[];
      }
    }, err => {
      this.loadComponent.startLoading(false);
      console.log(err);
      this.messageModel = new Message(
        'Protocolos',
        'Erro de conexão',
        'Ocorreu um erro ao listar os protocolos da base. Tente novamente.',
        'warning'
      );
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
    },
      () => {
        this.apiProtocolos.sanitizarDiretorioUpload().subscribe(err => { }, () => { });
        this.dataSource = new MatTableDataSource<DocumentoPreEditado>(this.lstProtocolos);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.loadComponent.startLoading(false);
      }
    );
  }

  filtroPesquisa() {
    const dialogRef = this.dialog.open(PopupFiltroPesquisaComponent);
    dialogRef.afterClosed().subscribe(result => {
      this.carregarFiltro();
    });
  }

  limparFiltro() {
    this.pesquisaProtocolos.idProtocolo = null;
    this.pesquisaProtocolos.documentoId = '';
    this.pesquisaProtocolos.cnpjFornecedor = '';
    this.pesquisaForm.controls['frmNomeFornecedor'].setValue('');
    this.pesquisaProtocolos.idPedido = '';
    this.pesquisaProtocolos.criacaoInicio = null;
    this.pesquisaProtocolos.criacaoFim = null;
    this.pesquisaProtocolos.emissaoInicio = null;
    this.pesquisaProtocolos.emissaoFim = null;
    this.pesquisaProtocolos.vencimentoInicio = null;
    this.pesquisaProtocolos.vencimentoFim = null;
    this.pesquisaProtocolos.conclusaoInicio = null;
    this.pesquisaProtocolos.conclusaoFim = null;
    this.pesquisaProtocolos.loginAprovador = '';
    this.pesquisaProtocolos.loginUsuarioCriacao = '';
    this.pesquisaProtocolos.loginResponsavel = null;
    this.pesquisaProtocolos.idFiltro = null;
    this.pesquisaProtocolos.statusProtocolo = null;
    this.pesquisaProtocolos.valor = null;
    this.pesquisaProtocolos.tipoProtocolo = null;
    this.pesquisaProtocolos.idTipoDocumento = null;
    this.pesquisaProtocolos.tipo = null;
  }

  setStep(index: number) {
    this.step = index;
  }

  NavigateProtocolo(documento: string) {
    localStorage.setItem('documento', JSON.stringify(documento));
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  filterData = (d: Date): boolean => {
    return d <= new Date();
  }

  validarDataCriacaoInicio(event: any) {
    let dataSelecionada = event.target.value || null;

    if (!dataSelecionada) {
      return;
    }

    dataSelecionada = moment(dataSelecionada, 'DD/MM/YYYY').toISOString();
    this.pesquisaProtocolos.criacaoInicio = new Date(dataSelecionada);
    this.pesquisaForm.controls['frmCriacaoInicio'].setValue(this.pesquisaProtocolos.criacaoInicio);

    if (this.pesquisaProtocolos.criacaoInicio === null) {
      return;
    }
  }

  validarDataCriacaoFim(event: any) {
    let dataSelecionada = event.target.value || null;

    if (!dataSelecionada) {
      return;
    }

    dataSelecionada = moment(dataSelecionada, 'DD/MM/YYYY').toISOString();
    this.pesquisaProtocolos.criacaoFim = new Date(dataSelecionada);
    this.pesquisaForm.controls['frmCriacaoFim'].setValue(this.pesquisaProtocolos.criacaoFim);

    if (this.pesquisaProtocolos.criacaoFim === null) {
      return;
    }
  }

  validarDataEmissaoInicio(event: any) {
    let dataSelecionada = event.target.value || null;

    if (!dataSelecionada) {
      return;
    }

    dataSelecionada = moment(dataSelecionada, 'DD/MM/YYYY').toISOString();
    this.pesquisaProtocolos.emissaoInicio = new Date(dataSelecionada);
    this.pesquisaForm.controls['frmEmissaoInicio'].setValue(this.pesquisaProtocolos.emissaoInicio);

    if (this.pesquisaProtocolos.emissaoInicio === null) {
      return;
    }
  }

  validarDataEmissaoFim(event: any) {
    let dataSelecionada = event.target.value || null;

    if (!dataSelecionada) {
      return;
    }

    dataSelecionada = moment(dataSelecionada, 'DD/MM/YYYY').toISOString();
    this.pesquisaProtocolos.emissaoFim = new Date(dataSelecionada);
    this.pesquisaForm.controls['frmEmissaoFim'].setValue(this.pesquisaProtocolos.emissaoFim);

    if (this.pesquisaProtocolos.emissaoFim === null) {
      return;
    }
  }

  validarDataVencimentoInicio(event: any) {
    let dataSelecionada = event.target.value || null;

    if (!dataSelecionada) {
      return;
    }

    dataSelecionada = moment(dataSelecionada, 'DD/MM/YYYY').toISOString();
    this.pesquisaProtocolos.vencimentoInicio = new Date(dataSelecionada);
    this.pesquisaForm.controls['frmVencimentoInicio'].setValue(this.pesquisaProtocolos.vencimentoInicio);

    if (this.pesquisaProtocolos.vencimentoInicio === null) {
      return;
    }
  }

  validarDataVencimentoFim(event: any) {
    let dataSelecionada = event.target.value || null;

    if (!dataSelecionada) {
      return;
    }

    dataSelecionada = moment(dataSelecionada, 'DD/MM/YYYY').toISOString();
    this.pesquisaProtocolos.vencimentoFim = new Date(dataSelecionada);
    this.pesquisaForm.controls['frmVencimentoFim'].setValue(this.pesquisaProtocolos.vencimentoFim);

    if (this.pesquisaProtocolos.vencimentoFim === null) {
      return;
    }
  }

  validarDataConclusaoInicio(event: any) {
    let dataSelecionada = event.target.value || null;

    if (!dataSelecionada) {
      return;
    }

    dataSelecionada = moment(dataSelecionada, 'DD/MM/YYYY').toISOString();
    this.pesquisaProtocolos.conclusaoInicio = new Date(dataSelecionada);
    this.pesquisaForm.controls['frmConclusaoInicio'].setValue(this.pesquisaProtocolos.conclusaoInicio);

    if (this.pesquisaProtocolos.conclusaoInicio === null) {
      return;
    }
  }

  validarDataConclusaoFim(event: any) {
    let dataSelecionada = event.target.value || null;

    if (!dataSelecionada) {
      return;
    }

    dataSelecionada = moment(dataSelecionada, 'DD/MM/YYYY').toISOString();
    this.pesquisaProtocolos.conclusaoFim = new Date(dataSelecionada);
    this.pesquisaForm.controls['frmConclusaoFim'].setValue(this.pesquisaProtocolos.conclusaoFim);

    if (this.pesquisaProtocolos.conclusaoFim === null) {
      return;
    }
  }
}
